<section class="c-cover t-alert-warn">

  <div class="c-cover__image"></div>

  <span class="c-cover__title-qualifier">
    Redação Nota 1000
  </span>

  <h1 class="c-cover__main-title">
    A melhor e mais completa plataforma de prática e correção de redações do Brasil.
  </h1>

  <div class="c-cover__controls">
    <button matRipple
            [routerLink]="['/home']" fragment="como-funciona"
            id="btn-vejacfunciona"
            class="c-cover__button c-button c-button--large c-button--solid-reversed">
      Veja como funciona

      <fa-icon class="u-margin-left-small" [icon]="['fas', 'arrow-alt-circle-down']"></fa-icon>
    </button>
    <br>

    <a matRipple
       [routerLink]="[ '/home/registro-candidato' ]"
       class="c-cover__button c-button c-button--solid-reversed">
      Seja um corretor de redações

      <fa-icon class="u-margin-left-small" [icon]="['fas', 'user-graduate']"></fa-icon>
    </a>
  </div>

</section>


<section class="c-hub-grid c-home-section t-primary"
         id="como-funciona">

  <h2 class="c-home-section__main-title">
    Simples
    <span class="u-wrapping-nowrap">e prático</span>
  </h2>

  <div class="c-home-section__intro">
    <p class="gamma">
      Na <strong>Redação Nota 1000</strong>, você recebe correções detalhadas
      e esclarecedoras, com sugestões práticas para melhorar seu texto. Então,
      basta focar seus estudos e ver sua nota subir, redação a redação!
    </p>
  </div>


  <div class="c-hub-grid-item c-hub-grid-item--first">
    <h3 class="c-hub-grid-item__title">
      <span class="c-hub-grid-item__number">1</span>
      Cadastre-se na plataforma
    </h3>
  </div>

  <p class="c-hub-grid-item__content">
    <span>
      Clique

      <!--suppress HtmlUnknownTarget -->
      <a href="/home?entrar"
         (click)="openSignUpOverlay($event)"
         class="c-hub-grid-item__link c-hub-grid-item__link--inline">
        aqui
      </a>

      para cadastrar-se ou entrar na plataforma.
    </span>
  </p>


  <div class="c-hub-grid-item c-hub-grid-item--second">
    <h3 class="c-hub-grid-item__title">
      <span class="c-hub-grid-item__number">2</span>
      Adquira um pacote
    </h3>
  </div>

  <p class="c-hub-grid-item__content">
    Contrate a melhor opção para seu objetivo: experimentar, treinar ou arrasar na redação.

    <a class="c-hub-grid-item__link" [routerLink]="['/home']" fragment="preco">
      Conheça as opções

      <fa-icon [icon]="['fas', 'arrow-alt-circle-down']"></fa-icon>
    </a>
  </p>


  <div class="c-hub-grid-item c-hub-grid-item--third">
    <h3 class="c-hub-grid-item__title">
      <span class="c-hub-grid-item__number">3</span>
      Envie sua redação
    </h3>
  </div>

  <p class="c-hub-grid-item__content">
    Escreva e envie sua redação, digitada na plataforma ou manuscrita
    e fotografada com o seu celular.
  </p>


  <div class="c-hub-grid-item c-hub-grid-item--fourth">
    <h3 class="c-hub-grid-item__title">
      <span class="c-hub-grid-item__number">4</span>
      Receba sua correção
    </h3>
  </div>

  <p class="c-hub-grid-item__content">
    Sua avaliação detalhada será realizada rapidamente!
  </p>


  <div class="c-hub-grid__image c-hub-grid__image--mobile">
    <img src="assets/images/alunoMobile.png"
         alt="tela de cadastro, mobile">
  </div>

  <div class="c-hub-grid__image c-hub-grid__image--desktop">
    <img src="assets/images/alunoDesktop.png"
         alt="tela de seleção de tema, desktop">
  </div>
</section>


<section class="c-pricing c-home-section t-danger" id="preco">
  <h2 class="c-pricing__main-title c-home-section__main-title">
    Pacotes
    <span class="u-wrapping-nowrap">e planos</span>
  </h2>

  <div class="c-pricing__intro c-home-section__intro">
    <p class="gamma">
      Bora treinar e arrasar na redação? <br>
      Veja nossos pacotes e planos especiais:
    </p>
  </div>

  <red-payment class="c-pricing__payment"></red-payment>

</section>
